{
  "dss": {
    "button": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "confirmDelete": "Yes, delete",
      "continue": "Continue",
      "logout": "Logout",
      "passwordReset": "Password Reset",
      "save": "Save",
      "verify": "Verify"
    },
    "error": {
      "403": "You don't have access to this page.",
      "404": "This page doesn't exist.",
      "generic": "An error has occurred. Please try again later.",
      "invalidConfirmationLink": "The confirmation link has expired or is otherwise invalid.",
      "throttling": "Too many attempts. This operation is blocked for a while.",
      "title": "Error",
      "title403": "Access denied",
      "title404": "Not found"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privacy Policy",
      "terms": "Terms & Conditions"
    },
    "label": {
      "CRMAccountNumber": "CRM Account Number",
      "contact": "Contact",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "First name",
      "help": "Help",
      "language": "Language",
      "lastname": "Last name",
      "male": "Mr.",
      "needHelp": "Need help?",
      "newPassword": "New password",
      "newPassword2": "Confirm new password",
      "oldPassword": "Current password",
      "organization": "Organization",
      "password": "Password",
      "required": "required",
      "salutation": "Salutation",
      "select": "Please select"
    },
    "lang": {
      "af": "Afrikaans",
      "ar": "Arabic",
      "bg": "Bulgarian",
      "ca": "Catalan",
      "cs": "Czech",
      "da": "Danish",
      "de": "German",
      "el": "Greek",
      "en": "English",
      "es": "Spanish",
      "et": "Estonian",
      "fi": "Finnish",
      "fr": "French",
      "he": "Hebrew",
      "hi": "Hindi",
      "hr": "Croatian",
      "hu": "Hungarian",
      "id": "Indonesian",
      "is": "Icelandic",
      "it": "Italian",
      "ja": "日本語 - Japanese",
      "kk": "Kazakh",
      "ko": "Korean",
      "lt": "Lithuanian",
      "lv": "Latvian",
      "ms": "Malay",
      "nl": "Dutch",
      "no": "Norwegian",
      "pl": "Polish",
      "pt": "Portuguese",
      "pt-BR": "Portuguese (Brazil)",
      "ro": "Romanian",
      "ru": "Russian",
      "sk": "Slovakian",
      "sl": "Slovenian",
      "sq": "Albanian",
      "sr": "Serbian",
      "sv": "Swedish",
      "th": "Thai",
      "tr": "Turkish",
      "uk": "Ukrainian",
      "vi": "Vietnamese",
      "zh": "简体中文 - Chinese",
      "zh-TW": "繁體中文 - Traditional Chinese"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "name": "Dealer Self-Service",
    "page": {
      "confirm": {
        "title": "Confirm Registration",
        "wait": "Please wait to complete account confirmation."
      },
      "otp": {
        "btnResend": "Resend verification code email",
        "msg": {
          "invalidOTP": "The entered one-time password is invalid.",
          "resendFail": "Failed to resend the code. Please retry again later."
        },
        "spamDetail": "Check your inbox and spam folder for an email from STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Did you not get an email?",
        "subtitle": "In order to continue, you need to verify your email address.",
        "title": "Verify your user account",
        "txtVerifyMail": "Please enter the new verification code we sent to your email address {email}"
      },
      "personal": {
        "msg": {
          "noChange": "There is nothing to update.",
          "updateError": "Failed to update personal data.",
          "updated": "Personal data was updated.",
          "userLoadErr": "Error loading user data. Please try again later."
        },
        "secOrganization": "Organization",
        "secPersonal": "Personal",
        "secSettings": "Preferred Settings",
        "title": "Personal Info"
      },
      "postPwSet": {
        "info": "You can now use your new password.",
        "link_name": "Continue to Self-Service",
        "link_url": "/user/ui/",
        "title": "Your password has been changed"
      },
      "resetPW": {
        "title": "Reset your password"
      },
      "security": {
        "2fa": {
          "availableMethods": "Available 2FA methods:",
          "info": "Two-factor authentication (2FA) is a security feature that adds an extra layer of protection to your account. It requires you to use two methods to log in, instead of just a username and password.",
          "method": {
            "email": "Email",
            "emailDesc": "Get one-time codes sent to you via email to complete authentication requests.",
            "oath": {
              "add": {
                "button": "Register Authenticator app"
              }
            }
          }
        },
        "authenticator": "Authenticator app",
        "infoFederatedAccount": "This account is managed by your organization's identity provider, so the password can't be changed here. To change your password, sign in through your organization's login page or contact your IT administrator.",
        "lastUse": "Last used at {0}.",
        "msg": {
          "invalidPassword": "Invalid current password provided.",
          "passwordAlreadyUsed": "Cannot reuse the last 5 passwords.",
          "pwUpdateError": "An error occurred when trying to change password.",
          "pwUpdated": "The password was changed."
        },
        "noDevice": "Not configured",
        "oathAdd": {
          "appInfo": "To make the STIHL login process easier, you can use Authenticator apps like {0}, {1}, {2}, etc. to generate one-time-password that are used as a second factor during the login process.<br/>If you have lost or forgotten your mobile device, you can still use the 2FA code sent by email at any time.<br/><br/>Please follow the instructions below to set up your Authentication device.",
          "badCode": "Invalid code, please try again.",
          "error": "An error occurred when trying to register the authenticator device.",
          "headScan": "1. Scan the QR code with your authenticator app",
          "headVerify": "2. Verify the code",
          "infoKey": "setup key",
          "infoKeyTitle": "Your two-factor secret",
          "infoScanBottom": "Unable to scan? You can use the {0} to manually configure your authenticator app.",
          "infoVerify": "Enter the code generated by your authenticator app.",
          "success": "Your authenticator device has been registered. You can now use it to sign in.",
          "title": "Register your Two-Factor Authentication device"
        },
        "oathDelete": {
          "error": "An error occurred when trying to delete the authenticator device.",
          "success": "The authenticator device was deleted."
        },
        "passkeys": {
          "about": {
            "info1": "Passkeys are pairs of cryptographic keys (a public key and a private key) that are stored by an authenticator you control. The authenticator can prove that a user is present and is authorized to use the passkey. Authenticators prove authorization with a PIN, passcode, biometric, or device password, depending on the authenticator's capabilities and configuration. Authenticators come in many forms, such as an iPhone or Android device, Windows Hello, a FIDO2 hardware security key, or a password manager.",
            "info2": "When you sign in to STIHL using a passkey, your authenticator uses public key cryptography to prove your identity to STIHL without ever sending the passkey. Passkeys are bound to a website domain, like stihl-sso.com, and require a secure connection, meaning that the web browser will refuse to authenticate to a lookalike phishing website. These properties make passkeys highly phishing-resistant, and much harder to attack than SMS or TOTP 2FA, which can be phished.",
            "info3": "Cloud-backed passkey services allow passkeys to be synced across devices (such as Apple devices, Android devices, or password managers) so they can be used from more places and are less easily lost. Once you have set up a synced passkey on one device, that passkey is available to use across multiple devices using the same service. For example, if you register a passkey with your iCloud account using your MacBook's Touch ID, you can then use that passkey with your face, fingerprint, PIN, or device password interchangeably across multiple devices tied to the same iCloud account.",
            "title": "About passkeys"
          },
          "add": {
            "button": "Add new Passkey",
            "error": "An error occurred when trying to add the new passkey.",
            "success": "A new Passkey was added."
          },
          "delete": {
            "button": "Delete Passkey",
            "error": "An error occurred when trying to delete this passkey.",
            "success": "The Passkey was deleted."
          },
          "edit": {
            "error": "An error occurred when trying to save the Passkey name.",
            "name": "Passkey Name",
            "success": "The Passkey name was updated.",
            "title": "Give your Passkey a name to distinguish it from other passkeys"
          },
          "info": "Passkey is a simple and secure alternative to passwords, that validate your identity using touch, facial recognition, a device password or a PIN.",
          "none": "No Passkey configured.",
          "reallyDelete": "Are you sure you want to delete the Passkey?",
          "registeredPasskeys": "Your registered Passkeys:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Are you sure you want to delete the authenticator device?",
        "secMFA": "Two-Factor Authentication",
        "secPwdChange": "Change password",
        "title": "Security"
      },
      "setPW": {
        "acceptTC": "Please confirm our {terms} and read our {privacy}.",
        "killSSO": "Invalidate all active sessions",
        "msg": {
          "tokenExpired": "The password link or code expired. Please follow the link to reset your password: {link}."
        },
        "privacy": "Data Privacy Policy",
        "terms": "Terms and Conditions",
        "title": "Enter new password"
      }
    },
    "validations": {
      "hasDigit": "Must contain digit(s)",
      "hasLowercase": "Must contain lowercase character(s)",
      "hasSpecial": "Must contain special character(s): {chars}",
      "hasUppercase": "Must contain uppercase character(s)",
      "invalidCharacters": "Contains invalid characters",
      "maxLength": "Maximum {max} characters allowed",
      "minLength": "Minimum {min} characters required",
      "notSameAsEmail": "Too similar to the email address",
      "onlyValidCharactersAllowed": "Only letters, numbers and spaces are allowed.",
      "required": "Required value",
      "sameAsPassword": "The passwords do not match",
      "tcAccepted": "Please confirm our terms and conditions.",
      "validEmail": "Invalid email address.",
      "validOTP": "Please enter the verification code."
    }
  }
}
